export default __webpack_public_path__ + "static/media/NoAds.adb2411b.svg";